import React, { useState } from 'react'

import { css, Global } from '@emotion/core'

import store from 'stores'

import { Provider } from 'helpers/state'

import resize, { useResize } from 'helpers/resize'

import useTimeout from 'hooks/useTimeout'

import detect from 'helpers/detect'

import Meta from './_meta'

function App ({ Component, pageProps }) {
  const [vh, setVh] = useState(false)
  const styles = css` :root { --vh: ${vh}px; }`
  const cb = () => setVh(resize.height())
  useResize(cb)

  useTimeout(() => {
    if (!detect.instagram) return
    resize.clear(true)
    cb()
  }, 200)

  return (
    <>
      <Meta key='meta' />
      { vh && (<Global styles={ styles } />)}
      <Provider store={ store }>
        <Component { ...pageProps } />
      </Provider>
    </>
  )
}

export default App
